import { Landmark } from "lucide-react";
import { BankAccountsFieldArray } from "back-office/shared/components/bank-accounts/BankAccountsFieldArray";
import { PlateformeFormFieldNames } from "../form/PlateformeFormFieldNames";
import { CreateSectionCard } from "./CreateSectionCard";

/**
 * Section « Comptes bancaires » de la création de plateforme : carte + le
 * composant partagé BankAccountsFieldArray (même logique que le gestionnaire).
 */
export const PlateformeBankAccountsSection: React.FC = () => (
  <CreateSectionCard
    id="section-comptes-bancaires"
    icon={Landmark}
    title="Comptes bancaires"
    subtitle="Facultatif — pour le versement des commissions."
  >
    <BankAccountsFieldArray
      name={PlateformeFormFieldNames.BankAccounts}
      emptyLabel="Aucun compte pour l'instant — ils serviront au versement des commissions dans la configuration des tunnels."
      helpText="Le RIB justificatif pourra être joint après la création, depuis la fiche de la société."
    />
  </CreateSectionCard>
);
